import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {SptRecorderService} from '@spout/global-web/data-access';

@Component({
  selector: 'spt-help-compressor-content',
  templateUrl: './help-compressor-content.component.html',
  styleUrls: ['./help-compressor-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelpCompressorContentComponent {
  constructor(private _recorder: SptRecorderService) {}
  refresh(): void {
    this._recorder.refreshAudioDeviceList().subscribe(() => {});
  }
}
